import type { FilterGroup } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import {
  ASSESSMENT_TEMPLATE_ID_PROP,
  COUNTRY_INDEX_PROP,
  COUNTRY_RISK_PROP,
  INDUSTRY_INDEX_PROP,
  INDUSTRY_RISK_PROP,
  SECTION_LEVEL_PROP,
  TOTAL_LEVEL_PROP,
} from '@app/src/hooks/getAssessmentFilterLabel'

function flattenArray(arr: string[][]): string[] {
  return arr.reduce((acc, val) => acc.concat(val), [])
}

export const extractCategoryFilters = (categoryFilters: FilterGroup[] | undefined): FilterGroup[] => {
  return (
    categoryFilters?.filter(
      filter =>
        ![
          COUNTRY_RISK_PROP,
          COUNTRY_INDEX_PROP,
          INDUSTRY_RISK_PROP,
          INDUSTRY_INDEX_PROP,
          ASSESSMENT_TEMPLATE_ID_PROP,
          TOTAL_LEVEL_PROP,
        ].includes(filter.name) && !filter.name.startsWith(SECTION_LEVEL_PROP),
    ) || []
  )
}

export const extractCategoryFilterValues = (categoryFilters: FilterGroup[] | undefined): string[] => {
  return flattenArray(categoryFilters?.map(cf => cf.filters?.[0]?.value as string[]) ?? [])
}
